import { render } from "@testing-library/react";
import { List } from "antd";
import moment from "moment";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CleanerMiddleware from "../../../store/Middlewares/CleanerMiddleware";
import styles from "./WorkSchedule.module.css";
const WorkSchedule = () => {

  const { t, i18n } = useTranslation();
  const { state } = useLocation();

  const userInfo = state?.screen ? state?.item : state
console.log('userInfo',userInfo)
  const dispatch = useDispatch();

  useEffect(() => {
    getJobsDetails();
    getLanguage();

  }, [])


  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };

  const JobDetailsList = useSelector(
    state => state.CleanerTaskSummaryReducer.CreateJobDetailsList,
  );

  const JobDetailsPagination = useSelector(
    state => state.CleanerTaskSummaryReducer.CreateJobDetailsPagination,
  );



  const getJobsDetails = () => {
    const data = {
      next_page_url: undefined,
      cleaner_id: userInfo?.id,
      status: 'active',
    };
    dispatch(CleanerMiddleware.getJobByCleanerid(data));


  };

  const onPressLoadMore = () => {
    let data = {
      next_page_url: JobDetailsPagination?.links?.next,
      cleaner_id: userInfo?.id,
      status: 'active',
    };
    dispatch(CleanerMiddleware.getJobByCleanerid(data));
  };

  const loadMore =
    JobDetailsPagination?.links?.next ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
          display: 'flex', justifyContent: 'center'
        }}
      >
        <button onClick={onPressLoadMore} className={styles.loadMore_button}>
          Load More
        </button>
      </div>
    ) : null;


  
  const renderItem = (item) => {
    return (
      <div className={styles.mainDiv}>
        <div className={styles.header}>
          <h3>{moment(item?.date).format('dddd')}</h3>
          <p>{moment(item?.date).format('MM-DD-YYYY')}</p>
        </div>
        <div className={styles.content}>
          <h3>{item?.customer_name}</h3>
          <p>{item?.location?.address}</p>
          <p>{moment('01 jan 1940 ' + item?.start_time).format('hh:mm A') +
            ' To ' +
            moment('01 jan 1940 ' + item?.end_time).format('hh:mm A')}</p>
        </div>
      </div>
    );
  };
  return (
    <List
      grid={{
        gutter: 16,
        //   xs: 2,
        sm: 1,
        md: 1,
        lg: 1,
        xl: 2,
        xxl: 2,
      }}
      className={styles.list}
      dataSource={JobDetailsList}
      footer={loadMore}
      renderItem={renderItem}
    />
  );
};
export default WorkSchedule;
